// extracted by mini-css-extract-plugin
module.exports = {"notPaid":"orders_notPaid__2HMiG","canceled":"orders_canceled__3pULg"};